/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  login.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:32
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { api, axios, axiosAPIUrl, Parameter } from "./index";
import { getDeviceFingerprint } from "@/utils/device";
import { Base64 } from "js-base64";
import { AuthHeader, ContentType, NotLoginAuthHeaderVal } from "@/constant/common";

export interface LoginResponse {
  // eslint-disable-next-line camelcase
  access_token: string;
  // eslint-disable-next-line camelcase
  refresh_token: string;
  scope: string;
  // eslint-disable-next-line camelcase
  token_type: string;
}
const oauthHeader = `Basic ${Base64.encode("web:123456")}`;
/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
/**
export async function login(parameter: any) {
  return axios<LoginResponse>({
    url: api.Login,
    method: "post",
    data: parameter,
    headers: {
      [ContentType]: "application/x-www-form-urlencoded",
      deviceId: await getDeviceFingerprint(),
      [AuthHeader]: `Basic ${Base64.encode("web:123456")}`,
    },
    transformRequest(params) {
      return Object.keys(params)
        .map((k) => `${k}=${encodeURIComponent(params[k])}`)
        .join("&");
    },
  });
}
*/
export async function getImgCaptchaUrl(username: string) {
  return axios<ArrayBuffer>({
    url: api.imgCaptcha,
    method: "get",
    responseType: "arraybuffer",
    params: {
      deviceId: await getDeviceFingerprint(),
      random: Math.random(),
      username: username,
    },
    extraParams: { showLoading: false },
  });
}

export function getInfo() {
  return axios({
    url: "/user/info",
    method: "get",
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
}

export function getCurrentUserNav() {
  return axios({
    url: "/user/nav",
    method: "get",
  });
}

export function logout() {
  return axios({
    url: "/oauth/logout",
    method: "delete",
    headers: {
      [AuthHeader]: oauthHeader,
    },
  });
}

/**
 * 获取验证码
 * @param parameter
 */
export function getSmsCodeByMobile(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<{ businessId?: string }>>({
      url: "cykjusercenter/register/web/getSmsCode",
      method: "post",
      data: parameter,
  });
}

/**
 * 验证码登录/注册
 * @param parameter
 */
export function registOrLoginphone (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjusercenter/register/web/registOrLoginphone",
    method: "post",
    data: parameter,
    headers: {
      [AuthHeader]: NotLoginAuthHeaderVal
    },
    extraParams: { showToastTip: false },
  });
}

/**
 * 登录
 * @param parameter
 */
export function login (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjusercenter/enter/web/login",
    method: "post",
    data: parameter,
    headers: {
      [AuthHeader]: NotLoginAuthHeaderVal,
    },
    extraParams: { showToastTip: false },
  });
}

/**
 * 忘记密码获取验证码
 * @param parameter
 */
export function getSmsCodeByforgetPassword (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjusercenter/enter/web/getSmsCodeByforgetPassword",
    method: "get",
    params: parameter,
    extraParams: { showToastTip: false },
  });
}

/**
 * 忘记密码确认
 * @param parameter
 */
export function forgetPasswordConfirm (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjusercenter/enter/web/forgetPasswordConfirm",
    method: "put",
    data: parameter,
    headers: {
      [AuthHeader]: NotLoginAuthHeaderVal,
    },
    extraParams: { showToastTip: false },
  });
}

/**
 * 重置密码确认
 * @param parameter
 */
export function forgetPasswordReset (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjusercenter/enter/web/forgetPasswordReset",
    method: "post",
    data: parameter,
    extraParams: { showToastTip: false },
  });
}

/**
 * 获取App版本最新版本
 * @param headers
 */
export function getAppVersionOrReleasePath (headers: any = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjusercenter/VI/getAppVersionOrReleasePath",
    method: "post",
    headers
  });
}

/**
 * 获取图片验证码
 * @param parameter
 */
export function getImgConfig (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjusercenter/VI/getImgConfig",
    method: "post",
    data: parameter
  });
}

/**
 * 缓存本次进入店铺信息到服务器
 * @param parameter
 */
export function cacheCompanyInfo (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjoperation/companyManage/cacheCompanyInfo",
    method: "post",
    data: parameter
  });
}

/**
 * 从服务器获取上次进入店铺信息
 * @param parameter
 */
export function getCacheCompanyInfo (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjoperation/companyManage/getCacheCompanyInfo",
    method: "get",
    params: parameter
  });
}
